/**
 * 正式运行时以已保存的产物格式为准，避免项目切换编辑模式但尚未重新保存时，
 * 用 remote runtime 加载旧的 CJS 产物。
 */
export function shouldUseRemoteRuntime(aiConfig, aiProjectInfo, { isPreview = false, isLiveDebug = false } = {}) {
    if (isLiveDebug)
        return true;
    if (isPreview) {
        return aiConfig?.useRemoteEditor === true;
    }
    const artifactModule = aiProjectInfo?.artifact?.meta?.module
        || aiProjectInfo?.artifactCos?.meta?.module;
    return artifactModule === 'esm';
}
/** ESM / 容器预览统一走远端宿主，旧 React CJS 继续使用原宿主。 */
export function resolveGogoRuntimeKind(framework, useRemoteRuntime) {
    if (useRemoteRuntime)
        return 'remote';
    return framework === 'react' ? 'react' : 'vue';
}
/** 发布产物只加载静态资源；仅编辑器 iframe 和容器实时预览连接 Vite HMR。 */
export function shouldEnableRemoteHmr(previewBridge, wsUrl) {
    return Boolean(previewBridge || wsUrl);
}
